import * as React from "react";
import { SVGProps } from "react";

const FraxShare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 201 201" {...props}>
    <g transform="translate(295.658 -75.719)">
      <circle
        cx={-195.044}
        cy={176.333}
        r={100.396}
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.437}
        style={{
          fontVariationSettings: "normal",
        }}
      />
      <path
        fill="#fff"
        d="m-239.539 119.12-6.73 6.73 8.515 8.516 8.535 8.516-.707 2.083c-.91 2.733-1.283 5.02-1.283 8.051 0 9.874 5.17 18.278 14.318 23.28 3.681 2.008 10.003 4.276 17.013 6.08 13.685 3.514 15.786 4.128 18.482 5.392 3.682 1.748 5.504 3.645 6.266 6.508.335 1.246.316 4.035-.018 5.374-.856 3.254-3.626 6.526-7.066 8.311-4.648 2.436-12.737 3.105-18.835 1.543-2.269-.557-5.486-2.138-7.103-3.458-3.291-2.715-5.857-7.4-6.992-12.811-.186-.856-.334-1.58-.353-1.618-.056-.074-19.096 1.785-19.189 1.897-.074.055-.018.836.112 1.729.595 4.295 2.1 9.408 3.83 12.96l1.004 2.064-8.274 8.274-8.256 8.274 6.75 6.75 6.73 6.73 8.535-8.534 8.516-8.516 1.47.614c7.772 3.272 19.43 4.295 30.735 2.659 2.715-.39 6.638-1.32 8.702-2.083l1.227-.446 8.163 8.163 8.144 8.144 6.73-6.731 6.75-6.75-7.567-7.567-7.55-7.55.949-1.933c1.97-3.96 2.79-7.326 2.956-11.956.298-8.832-1.99-15.489-7.195-20.974-5.43-5.708-11.547-8.423-28.821-12.774-12.179-3.05-17.422-5.15-19.505-7.79-2.064-2.604-2.25-6.248-.446-8.907 1.041-1.544 3.607-3.199 6.396-4.128 3.142-1.06 8.423-1.544 12.346-1.134 8.275.873 12.44 4.406 14.262 12.141.223.949.428 1.748.446 1.785.037.056 13.5-.427 17.534-.632l2.306-.111-.13-1.618c-.26-3.291-.911-6.229-2.101-9.297l-.651-1.73 8.386-8.404 8.386-8.386-6.731-6.75-6.75-6.73-8.479 8.479-8.497 8.497-2.064-.78c-5.076-1.897-9.985-2.734-17.218-2.939-7.903-.204-14.838.818-20.156 2.975l-1.97.8-8.554-8.516-8.553-8.516z"
      />
    </g>
  </svg>
);

export default FraxShare;
